export const ONE_DRIVE_PRO = 'OneDrivePro';
